import React from 'react'

import styles from './iconSwapper.module.css';

export const IconSwapper = ({icons}) => {
    return <div className={styles.IconSwapper}>
        {
            (icons ?? []).map((ic, i) => (<div
                key={i}
                className={styles.IconWrapper + ' ' + styles[ic.exit] + ' ' + (ic.active ? styles.Active : '')}
            >{ic.icon}</div>))
        }
    </div>
}